import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBoundingBoxThin = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 47.07450000000001,
			d: "M897.155 681.417v-342.36c-.043-30.513-16.39-58.8-42.795-74.035L554.795 93.842c-26.447-15.278-59.143-15.278-85.59 0L169.64 265.022c-26.405 15.235-42.752 43.522-42.795 74.035v342.36c.043 30.513 16.39 58.8 42.795 74.035l299.565 171.18c26.447 15.278 59.143 15.278 85.59 0l299.565-171.18c26.404-15.235 42.752-43.522 42.795-74.035"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 47.07450000000001,
			d: "M138.4 294.55 512 510.665 885.6 294.55M512 941.61V510.238"
		})
	]
});
export default SvgIconBoundingBoxThin;
